import { WeekScheduleDay } from 'graphql/generated/graphqlTypes';

export function generateMockWeekScheduleDay({
  dayName = 'mockWeekScheduleDayDayName',
  from = 'mockWeekScheduleDayFrom',
  to = 'mockWeekScheduleDayTo'
}: Partial<Omit<WeekScheduleDay, '__typename'>>): WeekScheduleDay {
  return {
    __typename: 'WeekScheduleDay',
    dayName,
    from,
    to
  };
}
